var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21046"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#235594"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 21043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6953 15.752C10.6953 13.5145 12.5091 11.7007 14.7466 11.7007C16.9841 11.7007 18.7979 13.5145 18.7979 15.752C18.7979 17.9895 16.9841 19.8033 14.7466 19.8033C12.5091 19.8033 10.6953 17.9895 10.6953 15.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3721 21.3332C11.4816 20.8516 12.9373 20.7036 14.7464 20.7036C16.5571 20.7036 18.0139 20.8519 19.1237 21.3345C20.3327 21.8602 21.0675 22.7556 21.4527 24.0199C21.6332 24.6125 21.1881 25.205 20.5747 25.205H8.91979C8.30569 25.205 7.85965 24.6116 8.04071 24.0179C8.42637 22.7535 9.1623 21.8583 10.3721 21.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2395 9.23833C22.3719 8.92056 22.822 8.92056 22.9545 9.23833L23.6519 10.9123C23.7082 11.0473 23.8402 11.1353 23.9865 11.1353H25.8207C26.158 11.1353 26.3268 11.5431 26.0884 11.7816L24.6049 13.265C24.5118 13.3581 24.4766 13.4943 24.5127 13.6209L25.101 15.6799C25.2003 16.0276 24.8127 16.3106 24.5118 16.11L22.798 14.9675C22.6763 14.8863 22.5177 14.8863 22.3959 14.9675L20.685 16.1081C20.3832 16.3093 19.9942 16.0254 20.0939 15.6767L20.6812 13.6209C20.7174 13.4943 20.6821 13.3581 20.589 13.265L19.1129 11.7889C18.8717 11.5477 19.0425 11.1353 19.3836 11.1353H21.2074C21.3537 11.1353 21.4857 11.0473 21.542 10.9123L22.2395 9.23833Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadLogo);
export default __webpack_public_path__ + "static/media/LeadLogo.75f96e62ba52eba8ca309afd46168878.svg";
export { ForwardRef as ReactComponent };